import React from 'react';

import { NavLink } from 'react-router-dom';

import { observer, inject } from 'mobx-react';

import { StringFormatter } from 'utils/StringFormatter';
import { constants } from 'utils/constants';
import { localeStrings as strings } from 'applicationConfig';

@inject('settingsStore')
@inject('userStore')
@observer
class ShellNotifications extends React.Component {
  displayNotifications = [];

  componentWillMount() {
    const notifications = this.props.userStore.notifications;
    const popupNotifications = notifications.getOneTimeNotifications();

    const messages = popupNotifications.map((n) =>
      strings.generic.notifications.subscriptionEndsSoon.replace(
        '$period',
        StringFormatter.formatShortDate(n.actionData.subscriptionExpirationPeriod)
      )
    );

    if (messages.length) {
      this.props.settingsStore.setAlertData({
        message: messages.join(' '),
        title: strings.generic.errorMessages.subscriptionDueToExpireTitles
      });
    }

    this.displayNotifications = notifications.getAll();
  }

  render() {
    return (
      <div className={' notifications  fix-widthed ' + (this.displayNotifications.length ? '' : 'hidden')}>
        {this.displayNotifications.map((notification, i) => {
          return (
            <div key={'notification-' + i}>
              {constants.REDIRECT_TO_SUBSCRIPTION === notification.actionId && (
                <div>
                  <span>{strings.generic.notifications.subscriptionExpired[0]} </span>
                  <NavLink to="/my-account/subscriptions" className="mailto">
                    {strings.pageTitles.mySubscriptions}
                  </NavLink>
                  <span>{strings.generic.notifications.subscriptionExpired[1]} </span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default ShellNotifications;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/ShellNotifications.jsx